import * as React from "react";

import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import {
  // eslint-disable-next-line no-unused-vars
  GridCellProps,
  GRID_COL_INDEX_ATTRIBUTE,
} from "@progress/kendo-react-grid";
import { useTranslation } from "react-i18next";
/**
 *
 * @param {GridCellProps} props
 * @returns
 */
const TranslateCell = (props) => {
  const field = props.field || "";
  const { t } = useTranslation();
  const value = props.dataItem[field];
  const navigationAttributes = useTableKeyboardNavigation(props.id);
  const data = React.useMemo(
    () =>
      t(props.tKey, { returnObjects: true }).find(
        (d) => d[props.dataItemKey || "value"] === value
      ),
    [t, value, props.tKey, props.dataItemKey]
  );
  return (
    <td
      aria-selected={props.isSelected}
      colSpan={props.colSpan}
      aria-colindex={props.ariaColumnIndex}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      {...navigationAttributes}
    >
      {data ? data[props.textField || "text"] : value}
    </td>
  );
};
export default TranslateCell;
